import { Link } from '@remix-run/react';
import { PAGE_POSITIONS } from 'types';
import { type CapiProductPage } from 'types/capi/pdp';

import Image from '~/components/Image';
import usePageData from '~/hooks/usePageData';
import gtm from '~/services/gtm.client';

const MoreColours = () => {
  const product = usePageData<CapiProductPage>();

  if (!product.variants.length) return null;

  const sendGtmEvent = (name: string) => {
    if (name)
      gtm.trackedButtonClick({
        buttonName: 'PRODUCT_CLICK',
        pagePosition: PAGE_POSITIONS.moreColours
      });
  };

  return (
    <div className="mb-6 flex flex-col gap-2">
      <p>More colours</p>
      <div className="flex h-20 w-full gap-x-3 overflow-x-scroll">
        {product.variants.map(({ image, path, name }) => (
          <Link
            className="h-full w-auto flex-shrink-0"
            key={image.url}
            to={path}
            onClick={() => sendGtmEvent(name)}
          >
            <div className="h-full overflow-hidden rounded-lg border border-concrete">
              <Image
                className="h-full"
                src={image.url}
                alt={image.alt}
                width={150}
                height={150}
                pad={product.pad_images}
                loading="eager"
              />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MoreColours;
